import { ConditionRegistryCategory } from '../../../registry/condition/ConditionRegistryCategory';
export class ConditionRegistryOrderedTask extends ConditionRegistryCategory {
    label = 'OrderedTask';
    constructor(parent) {
        super(parent);
        super.init();
    }
}
